import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';


@Component({
  selector: 'app-instance-details',
  templateUrl: './instance-details.component.html',
  styleUrls: ['./instance-details.component.scss'],
})
export class InstanceDetailsComponent implements OnInit {;
  is_default=0;
  connection_key;
  keyFile;
  breadcrumbList = [
    {
      label: 'Instances',
      embedurl: true,
      url: '/baseapp/instances'
    },
    {
      label: 'Details',
      embedurl: false,
      url: '/baseapp/instances/details'
    }
  ];
 

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    private route: ActivatedRoute,
    public helperService: HelperService) { }
    addInstanceForm: UntypedFormGroup;
    hide: boolean = true;
    hide1200: boolean = false;
    userIp;
    dbEnvObj; 
    ngOnInit() {
      this.addInstanceForm = this.formBuilder.group({
        instance: [{value:"",disabled:true}],
        ip_address: [{value:"",disabled:true}],
        username: [{value:"",disabled:true}],
        passphrase: [{value:"",disabled:true}],
        connection_key: [{value:"",disabled:true}],
        is_default: [{value:"",disabled:true}],
        hostname: [{value:"",disabled:true}],
        ssh_port: [{value:"",disabled:true}],
        port_range_from: [{value:"",disabled:true}],
        port_range_to: [{value:"",disabled:true}]
      });
   
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
    const id = this.route.snapshot.params['id'];
    this.getInstanceDetails(id);
    this.getUserIp();
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getInstanceDetails(user_id){
    // this.helperService.loader();
    this.getStorage().then((res)=>{
      let payload = {
        id: user_id
      };
      this.backendService.PostAPICall("getInstance", payload, res.token).subscribe(
        (data) => {
          // this.helperService.closeLoader();
          let res1 = data;
          this.dbEnvObj = data;
          //console.log(res1);
          this.connection_key = res1.connection_key;
          const file = new File([ new Blob([res1.connection_key]) ], res1.instance+".pem");
          // this.keyFile =window.URL.createObjectURL(new Blob([file]));
        //   const byteArray = new Uint8Array(res1.connection_key.data);

        // const url = window.URL.createObjectURL(new Blob([byteArray]));

          const link = document.createElement("a");
          var blob = new Blob([res1.connection_key], {type: 'Buffer'});
          const objectURL = URL.createObjectURL( blob );
          
          link.href = objectURL;
          link.href = URL.createObjectURL( blob );
          link.download =  res1.instance+".pem";
          this.keyFile = link.download;

          //console.log(this.dbEnvObj);
          this.addInstanceForm.patchValue(
          {
            instance: res1.instance,
            ip_address: res1.ip_address,
            username: res1.username,
            passphrase: res1.passphrase,
            connection_key: res1.connection_key,
            is_default: res1.is_default,
            hostname: res1.hostname,
            ssh_port: res1.ssh_port,
            port_range_from: res1.port_range_from,
            port_range_to: res1.port_range_to
          })
        },
        (error)=>{
          //console.log(error);
          // this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  getUserIp(){
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
    })
  }
  
  download(){
    
    const link = document.createElement("a");
    var blob = new Blob([this.connection_key], {type: 'Buffer'});
    const objectURL = URL.createObjectURL( blob );
    link.href = objectURL;
    link.href = URL.createObjectURL( blob );
    link.download = this.keyFile;
    link.click()
  }
}
